module.exports = __webpack_public_path__ + "static/fipctransport4-c975edd2bdd8330ca718da953afdcf0c.jpeg";